module.exports = __webpack_public_path__ + "img/well_project_bg.5e3f72e9.png";